/**
 * @author: Khanh Le <quockhanhle1997@gmail.com>
 * @date: 29/08/2023
 */
export const LARGER = 'LARGER';
export const SMALLER = 'SMALLER';
export const USER_CREATED_DATE = "USER_CREATED_DATE";

export default {
    namespace: 'userCreatedDateModule',

    state:() => ({
        isLargerDefault: ''
    }),

    actions: {
        [LARGER](context) {
            context.commit(USER_CREATED_DATE, LARGER);
        },
        [SMALLER](context) {
            context.commit(USER_CREATED_DATE, SMALLER);
        },
    },
    mutations: {
        [USER_CREATED_DATE](state, payload = '') {
            state.isLargerDefault = payload;
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/userCreatedDateModule.js